import React, { useEffect, useState } from 'react'
import Layout from './layout'
import Subpages from './public/subpages'
import useMediaQuery from '../hooks/useMediaQuery'
import { Link, useParams } from 'react-router-dom'
import { BASE_URL, getNewList } from '../api/api'
import Pagination from './pagination'
import NavLink from './navLink'

const Zjzk = () => {
  const isMobile = useMediaQuery()

  const { channel_id = 1, page = 1 } = useParams()
  const pagesize = 60

  const [data, setData] = useState([])

  useEffect(() => {
    getNewList(
      `archives/newsList?pagesize=${pagesize}&channel_id=${channel_id}&page=${page}`.replace(
        '.html',
        ''
      )
    ).then(res => {
      setData(res?.data)
    })
  }, [pagesize, channel_id, page])

  return (
    <Layout>
      <Subpages className="px-5 lg:px-0 mb-10 lg:mb-0" name={data?.channel?.name}>
        <div className="flex flex-row justify-between flex-wrap">
          {data?.list?.data?.map(({ id, image = '', title, outlink }) => (
            <NavLink
              isOutLink={!!outlink}
              className="w-[30%] lg:w-auto"
              to={outlink || `/wzxq/id/${id}`}
              key={id}
            >
              <img
                className="mt-0"
                src={`${BASE_URL}${image}`}
                style={{ width: isMobile ? '100%' : 190, height: 'auto' }}
                alt=""
              />
              <p className="text-left mt-4 font-sourceHan text-[#333333] max-w-[190px] break-words">
                {title}
              </p>
            </NavLink>
          ))}
          <div className="w-[30%] lg:w-[190px]"></div>
          <div className="w-[190px]"></div>
          <div className="w-[190px]"></div>
          <div className="w-[190px]"></div>
          <div className="w-[190px]"></div>
        </div>
        <Pagination
          count={data?.list?.total}
          pagesize={pagesize}
          page={data?.list?.current_page}
          totalPage={data?.list?.last_page}
        />
      </Subpages>
    </Layout>
  )
}

export default Zjzk
